export default {"src":"/_next/static/media/linkedin.1f0fd84f.svg","height":30,"width":31,"blurWidth":0,"blurHeight":0};